import api from '@/api/base'
import cache from '@/api/cache'
import { t } from '@/global/i18n'

const apiWithCache = {
  async get(url, config = {}, useCaching = false, retryOptions = { retries: 0 }) {
    const cacheKey = `get:${url}:${JSON.stringify(config)}`

    if (useCaching) {
      const cachedData = cache.get(cacheKey)
      if (cachedData) {
        return cachedData
      }
    }

    try {
      return await handleRequest(() => api.get(url, config), retryOptions)
    } catch (error) {
      console.error(`${t('errors.api.general.networkError')} ${url}:`, error)
      throw error
    }
  },

  async post(url, data = {}, config = {}, retryOptions = { retries: 0 }) {
    return handleRequest(() => api.post(url, data, config), retryOptions)
  },

  async put(url, data = {}, config = {}, retryOptions = { retries: 0 }) {
    return handleRequest(() => api.put(url, data, config), retryOptions)
  },

  async delete(url, config = {}, retryOptions = { retries: 0 }) {
    return handleRequest(() => api.delete(url, config), retryOptions)
  },

  async patch(url, data = {}, config = {}, retryOptions = { retries: 0 }) {
    return handleRequest(() => api.patch(url, data, config), retryOptions)
  },
}

async function handleRequest(requestFn, { retries = 0, delay = 1000 } = {}) {
  let attempt = 0
  while (attempt <= retries) {
    try {
      return await requestFn()
    } catch (error) {
      if (attempt === retries) {
        throw error
      }
      attempt++
      await new Promise((resolve) => setTimeout(resolve, delay))
    }
  }
}

export default apiWithCache
